import { func } from 'prop-types';
import React from 'react';

const CloseButton = ({ onClick }) => {
	return (
		<div className="close-btn" onClick={onClick}>
			<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
		</div>
	);
};

CloseButton.propTypes = {
	onClick: func
};

export default CloseButton;
